import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { MetadataArgsStorage } from "../metadata-args/MetadataArgsStorage";
import { EntitySchemaEmbeddedError } from "./EntitySchemaEmbeddedError";
/**
 * Transforms entity schema into metadata args storage.
 * The result will be just like entities read from decorators.
 */
export var EntitySchemaTransformer = /*#__PURE__*/function () {
  function EntitySchemaTransformer() {
    _classCallCheck(this, EntitySchemaTransformer);
  }
  _createClass(EntitySchemaTransformer, [{
    key: "transform",
    value:
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    /**
     * Transforms entity schema into new metadata args storage object.
     */
    function transform(schemas) {
      var _this = this;
      var metadataArgsStorage = new MetadataArgsStorage();
      schemas.forEach(function (entitySchema) {
        var options = entitySchema.options;
        // add table metadata args from the schema
        var tableMetadata = {
          target: options.target || options.name,
          name: options.tableName,
          database: options.database,
          schema: options.schema,
          type: options.type || "regular",
          orderBy: options.orderBy,
          synchronize: options.synchronize,
          withoutRowid: !!options.withoutRowid,
          expression: options.expression
        };
        metadataArgsStorage.tables.push(tableMetadata);
        _this.transformColumnsRecursive(options, metadataArgsStorage);
      });
      return metadataArgsStorage;
    }
  }, {
    key: "transformColumnsRecursive",
    value: function transformColumnsRecursive(options, metadataArgsStorage) {
      var _this2 = this;
      // add columns metadata args from the schema
      Object.keys(options.columns).forEach(function (columnName) {
        var column = options.columns[columnName];
        var regularColumn = column;
        var mode = "regular";
        if (regularColumn.createDate) mode = "createDate";
        if (regularColumn.updateDate) mode = "updateDate";
        if (regularColumn.deleteDate) mode = "deleteDate";
        if (regularColumn.version) mode = "version";
        if (regularColumn.treeChildrenCount) mode = "treeChildrenCount";
        if (regularColumn.treeLevel) mode = "treeLevel";
        if (regularColumn.objectId) mode = "objectId";
        var columnArgs = {
          target: options.target || options.name,
          mode: mode,
          propertyName: columnName,
          options: {
            type: regularColumn.type,
            name: regularColumn.objectId ? "_id" : regularColumn.name,
            primaryKeyConstraintName: regularColumn.primaryKeyConstraintName,
            length: regularColumn.length,
            width: regularColumn.width,
            nullable: regularColumn.nullable,
            readonly: regularColumn.readonly,
            update: regularColumn.update,
            select: regularColumn.select,
            insert: regularColumn.insert,
            primary: regularColumn.primary,
            unique: regularColumn.unique,
            comment: regularColumn.comment,
            default: regularColumn.default,
            onUpdate: regularColumn.onUpdate,
            precision: regularColumn.precision,
            scale: regularColumn.scale,
            zerofill: regularColumn.zerofill,
            unsigned: regularColumn.unsigned,
            charset: regularColumn.charset,
            collation: regularColumn.collation,
            enum: regularColumn.enum,
            enumName: regularColumn.enumName,
            asExpression: regularColumn.asExpression,
            generatedType: regularColumn.generatedType,
            hstoreType: regularColumn.hstoreType,
            array: regularColumn.array,
            transformer: regularColumn.transformer,
            spatialFeatureType: regularColumn.spatialFeatureType,
            srid: regularColumn.srid
          }
        };
        metadataArgsStorage.columns.push(columnArgs);
        if (regularColumn.generated) {
          var generationArgs = {
            target: options.target || options.name,
            propertyName: columnName,
            strategy: typeof regularColumn.generated === "string" ? regularColumn.generated : "increment"
          };
          metadataArgsStorage.generations.push(generationArgs);
        }
        if (regularColumn.unique) metadataArgsStorage.uniques.push({
          target: options.target || options.name,
          columns: [columnName]
        });
      });
      // add relation metadata args from the schema
      if (options.relations) {
        Object.keys(options.relations).forEach(function (relationName) {
          var relationSchema = options.relations[relationName];
          var relation = {
            target: options.target || options.name,
            propertyName: relationName,
            relationType: relationSchema.type,
            isLazy: relationSchema.lazy || false,
            type: relationSchema.target,
            inverseSideProperty: relationSchema.inverseSide,
            isTreeParent: relationSchema.treeParent,
            isTreeChildren: relationSchema.treeChildren,
            options: {
              eager: relationSchema.eager || false,
              cascade: relationSchema.cascade,
              nullable: relationSchema.nullable,
              onDelete: relationSchema.onDelete,
              onUpdate: relationSchema.onUpdate,
              deferrable: relationSchema.deferrable,
              // primary: relationSchema.primary,
              createForeignKeyConstraints: relationSchema.createForeignKeyConstraints,
              persistence: relationSchema.persistence,
              orphanedRowAction: relationSchema.orphanedRowAction
            }
          };
          metadataArgsStorage.relations.push(relation);
          // add join column
          if (relationSchema.joinColumn) {
            if (typeof relationSchema.joinColumn === "boolean") {
              var joinColumn = {
                target: options.target || options.name,
                propertyName: relationName
              };
              metadataArgsStorage.joinColumns.push(joinColumn);
            } else {
              var joinColumnsOptions = Array.isArray(relationSchema.joinColumn) ? relationSchema.joinColumn : [relationSchema.joinColumn];
              var _iterator = _createForOfIteratorHelper(joinColumnsOptions),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var joinColumnOption = _step.value;
                  var _joinColumn = {
                    target: options.target || options.name,
                    propertyName: relationName,
                    name: joinColumnOption.name,
                    referencedColumnName: joinColumnOption.referencedColumnName,
                    foreignKeyConstraintName: joinColumnOption.foreignKeyConstraintName
                  };
                  metadataArgsStorage.joinColumns.push(_joinColumn);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }
          // add join table
          if (relationSchema.joinTable) {
            if (typeof relationSchema.joinTable === "boolean") {
              var joinTable = {
                target: options.target || options.name,
                propertyName: relationName
              };
              metadataArgsStorage.joinTables.push(joinTable);
            } else {
              var _joinTable = {
                target: options.target || options.name,
                propertyName: relationName,
                name: relationSchema.joinTable.name,
                database: relationSchema.joinTable.database,
                schema: relationSchema.joinTable.schema,
                joinColumns: relationSchema.joinTable.joinColumn ? [relationSchema.joinTable.joinColumn] : relationSchema.joinTable.joinColumns,
                inverseJoinColumns: relationSchema.joinTable.inverseJoinColumn ? [relationSchema.joinTable.inverseJoinColumn] : relationSchema.joinTable.inverseJoinColumns
              };
              metadataArgsStorage.joinTables.push(_joinTable);
            }
          }
        });
      }
      // add relation id metadata args from the schema
      if (options.relationIds) {
        Object.keys(options.relationIds).forEach(function (relationIdName) {
          var relationIdOptions = options.relationIds[relationIdName];
          var relationId = {
            propertyName: relationIdName,
            relation: relationIdOptions.relationName,
            target: options.target || options.name,
            alias: relationIdOptions.alias,
            queryBuilderFactory: relationIdOptions.queryBuilderFactory
          };
          metadataArgsStorage.relationIds.push(relationId);
        });
      }
      // add index metadata args from the schema
      if (options.indices) {
        options.indices.forEach(function (index) {
          var indexArgs = {
            target: options.target || options.name,
            name: index.name,
            unique: index.unique === true ? true : false,
            spatial: index.spatial === true ? true : false,
            fulltext: index.fulltext === true ? true : false,
            nullFiltered: index.nullFiltered === true ? true : false,
            parser: index.parser,
            synchronize: index.synchronize === false ? false : true,
            where: index.where,
            sparse: index.sparse,
            columns: index.columns
          };
          metadataArgsStorage.indices.push(indexArgs);
        });
      }
      // add unique metadata args from the schema
      if (options.uniques) {
        options.uniques.forEach(function (unique) {
          var uniqueArgs = {
            target: options.target || options.name,
            name: unique.name,
            columns: unique.columns,
            deferrable: unique.deferrable
          };
          metadataArgsStorage.uniques.push(uniqueArgs);
        });
      }
      // add check metadata args from the schema
      if (options.checks) {
        options.checks.forEach(function (check) {
          var checkArgs = {
            target: options.target || options.name,
            name: check.name,
            expression: check.expression
          };
          metadataArgsStorage.checks.push(checkArgs);
        });
      }
      // add exclusion metadata args from the schema
      if (options.exclusions) {
        options.exclusions.forEach(function (exclusion) {
          var exclusionArgs = {
            target: options.target || options.name,
            name: exclusion.name,
            expression: exclusion.expression
          };
          metadataArgsStorage.exclusions.push(exclusionArgs);
        });
      }
      if (options.embeddeds) {
        Object.keys(options.embeddeds).forEach(function (columnName) {
          var embeddedOptions = options.embeddeds[columnName];
          if (!embeddedOptions.schema) throw EntitySchemaEmbeddedError.createEntitySchemaIsRequiredException(columnName);
          var embeddedSchema = embeddedOptions.schema.options;
          metadataArgsStorage.embeddeds.push({
            target: options.target || options.name,
            propertyName: columnName,
            isArray: embeddedOptions.array === true,
            prefix: embeddedOptions.prefix !== undefined ? embeddedOptions.prefix : undefined,
            type: function type() {
              return (embeddedSchema === null || embeddedSchema === void 0 ? void 0 : embeddedSchema.target) || embeddedSchema.name;
            }
          });
          _this2.transformColumnsRecursive(embeddedSchema, metadataArgsStorage);
        });
      }
    }
  }]);
  return EntitySchemaTransformer;
}();